import {CustomMenuItem} from '@app/objects/CustomMenuItem';

const servicesChildren: CustomMenuItem[] = [
	{
		path: '/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
	},
	{
		path: '/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
	},
	{
		path: '/our-services/aftercare',
		name: 'Cremation & Aftercare',
	},
	{
		path: '/our-services/telehospice',
		name: 'Telehospice',
	},
	{
		path: '/our-services/pet-loss-support',
		name: 'Pet Loss Support',
	},
	{
		path: 'https://info.lapoflove.com/keepsakes',
		name: 'Pet Memorial Keepsakes',
		externalLink: true,
		newTab: true
	},
];

const qualityOfLifeChildren: CustomMenuItem[] = [
	{
		path: '/quality-of-life-assessment',
		name: 'Quality-of-Life Assessment'
	},
	{
		path: '/how-will-i-know-it-is-time',
		name: 'How Will I Know It\'s Time'
	},
	{
		path: '/how-will-i-know-it-is-time/lap-of-love-quality-of-life-scale.pdf',
		name: 'Quality-of-Life Scale',
		externalLink: true,
		newTab: true
	},
	{
		path: '/how-will-i-know-it-is-time/interactive-quality-of-life-assessment-and-diary.pdf',
		name: 'Quality-of-Life Daily Assessment',
		externalLink: true,
		newTab: true
	}
];

const communityChildren: CustomMenuItem[] = [
	{
		path: '/pet-memorial',
		name: 'Pet Memorials',
	},
	{
		path: '/veterinarian-testimonials',
		name: 'Testimonials',
	},
	{
		path: '/angel-fund',
		name: 'Angel Fund',
	},
	{
		path: '/pet-loss-support-resources',
		name: 'Pet Loss Resources',
	},
];

const aboutUsLeft: CustomMenuItem[] = [
	{
		path: '',
		name: 'About Us',
	},
	{
		path: '/about-us/who-we-are',
		name: 'Who We Are',
	},
	{
		path: 'https://lapoflovejobs.workable.com',
		name: 'Join Our Team',
		externalLink: true,
		newTab: true
	},
	{
		path: '/about-us/support-center-team',
		name: 'Support Center Team',
	},
	{
		path: '/about-us/student-externship',
		name: 'Student Externship',
	},
	{
		path: '/in-the-news/press-clippings',
		name: 'In the News',
	},
];

const aboutUsRight: CustomMenuItem[] = [
	{
		path: '',
		name: 'Join Our Team',
	},
	{
		path: 'https://apply.workable.com/lapoflovejobs/',
		name: 'Veterinarian',
	},
	{
		path: '/careers/become-a-care-coordinator',
		name: 'Care Coordinator',
	},
];

const educatResources: CustomMenuItem[] = [
	{
		path: '',
		name: 'Educational Resources'
	},
	{
		path: '/resource-center/common-diseases-in-cats',
		name: 'Common Cat Diseases'
	},
	{
		path: '/resource-center/common-diseases-in-dogs',
		name: 'Common Dog Diseases'
	},
	{
		path: '/resource-center/symptom-management',
		name: 'Symptom Management'
	}
];

const educatResourcesMobile: CustomMenuItem[] = [
	{
		path: '/resource-center/common-diseases-in-cats',
		name: 'Common Cat Diseases'
	},
	{
		path: '/resource-center/common-diseases-in-dogs',
		name: 'Common Dog Diseases'
	},
	{
		path: '/resource-center/symptom-management',
		name: 'Symptom Management'
	}
];

const addResources: CustomMenuItem[] = [
	{
		path: '',
		name: 'Additional Resources'
	},
	{
		path: '/blog',
		name: 'Blog'
	},
	{
		path: '/newsletter',
		name: 'Newsletter'
	},
	{
		path: '/videos',
		name: 'Videos'
	},
	{
		path: '/faq',
		name: 'FAQ'
	}
];

const addResourcesMobile: CustomMenuItem[] = [
	{
		path: '/blog',
		name: 'Blog'
	},
	{
		path: '/newsletter',
		name: 'Newsletter'
	},
	{
		path: '/videos',
		name: 'Videos'
	},
	{
		path: '/faq',
		name: 'FAQ'
	}
];

const supportResources: CustomMenuItem[] = [
	{
		path: '',
		name: 'Support Resources'
	},
	{
		path: '/how-will-i-know-it-is-time',
		name: 'How Will I Know It\'s Time'
	},
	{
		path: '/quality-of-life-calendar.pdf',
		name: 'Pet Quality-of-Life Calendar',
		externalLink: true,
		newTab: true
	},
	{
		path: '/pet-loss-support-resources',
		name: 'Pet Loss and Grief',
	},
];

const supportResourcesMobile: CustomMenuItem[] = [
	{
		path: '/how-will-i-know-it-is-time',
		name: 'How Will I Know It\'s Time'
	},
	{
		path: '/quality-of-life-calendar.pdf',
		name: 'Pet Quality of Life Calendar',
		externalLink: true,
		newTab: true
	},
	{
		path: '/pet-loss-support-resources',
		name: 'Pet Loss and Grief',
	},
];

const vetAccess: CustomMenuItem[] = [
	{
		path: '',
		name: 'Veterinary Access',
	},
	{
		path: '/veterinary-resource-center',
		name: 'Login / Sign Up'
	}
];

const vetAccessMobile: CustomMenuItem[] = [
	{
		path: '/veterinary-resource-center',
		name: 'Login / Sign Up'
	}
];

const vetResources: CustomMenuItem[] = [
	{
		path: '',
		name: 'Veterinary Resources',
	},
	{
		path: '/veterinary-resources/hospice-pain-management',
		name: 'Hospice Pain Management',
	},
	{
		path: '/veterinary-resources/euthanasia-sedation-protocols',
		name: 'Euthanasia Sedation Protocols'
	},
	{
		path: '/veterinary-resources/euthanasia-best-practices',
		name: 'Euthanasia Best Practices'
	},
	{
		path: '/veterinary-resources/geriatric-clinic-tips',
		name: 'Geriatric Clinic Tips'
	},
	{
		path: '/veterinary-resources/faq',
		name: 'FAQ'
	}
];

const vetResourcesMobile: CustomMenuItem[] = [
	{
		path: '/veterinary-resources/hospice-pain-management',
		name: 'Hospice Pain Management',
	},
	{
		path: '/veterinary-resources/euthanasia-sedation-protocols',
		name: 'Euthanasia Sedation Protocols'
	},
	{
		path: '/veterinary-resources/euthanasia-best-practices',
		name: 'Euthanasia Best Practices'
	},
	{
		path: '/veterinary-resources/geriatric-clinic-tips',
		name: 'Geriatric Clinic Tips'
	},
	{
		path: '/veterinary-resources/faq',
		name: 'FAQ'
	}
];

const resourcesArrows: CustomMenuItem[] = [
	{
		path: '',
		name: 'Family Resource Center',
		withIcon: true,
		switcher: true,
		children: [educatResources, supportResources, addResources]
	},
	{
		path: '',
		name: 'Veterinary Resource Center',
		withIcon: true,
		switcher: true,
		children: [vetAccess]
	}
];

const resourcesEdu: CustomMenuItem[] = [
	{
		path: '',
		name: 'Quality of Life Resources',
	},
	{
		path: '/quality-of-life-assessment',
		name: 'Quality of Life Assessment',
	},
	{
		path: '/how-will-i-know-it-is-time',
		name: 'How will I know when it’s time?',
	},
	{
		path: '/',
		name: 'The Pet Hospice Journal',
	},
	{
		path: '/quality-of-life/grey-muzzle-app',
		name: 'Grey Muzzle Quality of Life App',
	},
];

export const menu: CustomMenuItem[] = [
	{
		path: '',
		name: 'Services',
		children: [servicesChildren],
	},
	{
		path: '',
		name: 'Resources',
		children: [resourcesArrows],
		childrenFullWidth: true,
		withSwitcher: true
	},
	{
		path: '',
		name: 'Quality of Life',
		children: [qualityOfLifeChildren]
	},
	{
		path: '',
		name: 'Community',
		children: [communityChildren],
	},
	{
		path: '',
		name: 'About Us',
		children: [aboutUsLeft],
	},
];

export const mobileMenu: CustomMenuItem[] = [
	{
		path: '',
		name: 'Services',
		children: [servicesChildren],
	},
	{
		path: '',
		name: 'Family Resource Center',
		children: [educatResourcesMobile, supportResourcesMobile, addResourcesMobile],
		childrenFullWidth: true,
		withSwitcher: true
	},
	{
		path: '',
		name: 'Veterinary Resource Center',
		children: [vetAccessMobile],
		childrenFullWidth: true,
		withSwitcher: true
	},
	{
		path: '',
		name: 'Quality of Life',
		children: [qualityOfLifeChildren]
	},
	{
		path: '',
		name: 'Community',
		children: [communityChildren],
	},
	{
		path: '',
		name: 'About Us',
		children: [aboutUsLeft.slice(1), aboutUsRight],
	},
];
